'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const Template = require('communication/ui/template/task/assignee-edit.hbs');

const EditItem = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: Template,
    triggers: {
        'click .remove': 'remove'
    },
    regions: {
        icon: '.assignee-icon',
        title: '.assignee-name',
    },

    onRender: function() {
        // 担当者がプロジェクトから外された場合、担当者として表示されていないのに
        // 通知が飛んでしまうという事態を防ぐために groupMember を参照して表示する

        const group = this.getOption('context').getGroup();
        const groupMember = group.getMembers({withSuspended: true}).getMemberByUser(this.model);
        this.showChildView('icon', new GroupMemberIconView({
            model: groupMember
        }));
        this.showChildView('title', new GroupMemberNameView({
            model: groupMember
        }));
    },

    templateContext: function() {
        // ロールの表示のために projectMember を参照

        const project = this.getOption('context').getProject();
        const projectMember = project.getMembers().getMemberByUser(this.model);

        return {
            role: projectMember ? i18n.t(`base:project-role.${projectMember.getRole()}`) : i18n.t('base:non-project-member')
        };
    }
});

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: EditItem,

    childViewOptions: function() {
        return {
            context: this.getOption('context')
        }
    },

    onChildviewRemove: function(child) {
        this.trigger('remove:member');
        this.triggerMethod('remove', child);
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/assignee-edit.js